import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect } from 'react';
import { RemovablePill, Pill, OverflowPill, LabeledPills } from '@elliemae/ds-basic/Pills';

function FilterLabeledPills(_ref) {
  var groupId = _ref.groupId,
      label = _ref.label,
      pills = _ref.pills,
      _ref$onRemove = _ref.onRemove,
      _onRemove = _ref$onRemove === void 0 ? function () {
    return null;
  } : _ref$onRemove,
      onFocusGroupSet = _ref.onFocusGroupSet,
      onFocusNextGroup = _ref.onFocusNextGroup,
      onFocusPreviousGroup = _ref.onFocusPreviousGroup,
      _ref$overflowQuantity = _ref.overflowQuantity,
      overflowQuantity = _ref$overflowQuantity === void 0 ? 3 : _ref$overflowQuantity;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      overflowOptions = _useState2[0],
      setOverflowOptions = _useState2[1];

  useEffect(function () {
    if (pills.length > overflowQuantity) {
      var overflow = pills.filter(function (pill, index) {
        return index >= overflowQuantity;
      });
      var options = overflow.map(function (pill) {
        return {
          label: pill.value
        };
      });
      setOverflowOptions(options);
    }
  }, [pills]);
  var pillGroup = pills.map(function (pill) {
    var PillComponent = !pill.fixed ? RemovablePill : Pill;
    return /*#__PURE__*/React.createElement(PillComponent, {
      key: pill.value,
      label: pill.value,
      onRemove: function onRemove() {
        return _onRemove({
          pill: pill,
          group: groupId
        });
      }
    });
  }).filter(function (pill, index) {
    return index < overflowQuantity;
  });
  var overflowPills = pills.length > overflowQuantity && /*#__PURE__*/React.createElement(OverflowPill, {
    label: "+".concat(pills.length - overflowQuantity),
    options: overflowOptions
  });
  return /*#__PURE__*/React.createElement(LabeledPills, {
    label: label,
    onFocusGroupSet: onFocusGroupSet,
    onFocusNextGroup: onFocusNextGroup,
    onFocusPreviousGroup: onFocusPreviousGroup
  }, pillGroup, overflowPills);
}

FilterLabeledPills.propTypes = {};

export default FilterLabeledPills;
//# sourceMappingURL=FilterLabeledPills.js.map
